import { Component, OnInit } from '@angular/core';
import { PortalService } from '../../services/portal.service';

@Component({
  templateUrl: './home.page.html',
  styleUrls: ['./home.page.scss']
})
export class HomePage implements OnInit {

  sideNavigation: any[] = [];

  constructor(private portalService: PortalService) {
  }

  ngOnInit() {
    this.portalService.getSideNavigation()
      .subscribe(sideNavigation => this.sideNavigation = [...sideNavigation]);
  }

  navigate() {
    if(this.sideNavigation.length > 0)
      return '/map/' + this.sideNavigation[0].label;
    else return '/map';
  }

}
